import { API } from 'shared/constants/AppEnums';
import jwtAxios from "@crema/services/auth/jwt-auth";
import { updateRows } from "./dataTable";
import {FETCH_ERROR,FETCH_START, GET_TITLE_ADMINTOOLS,FETCH_SUCCESS, GET_TITLE_DETAIL_ADMINTOOLS, UPDATE_DATATABLE_TABLE_INFO, SHOW_MESSAGE, GET_TITLE_OPTIONS} from "shared/constants/ActionTypes";


export const onGetListTitle = (limit = 10,page = 0,search='') => {
    return (dispatch) => {
      dispatch({ type: FETCH_START });
      let url = API.GET_TITLE_ADMINTOOLS +`?limit=${limit}&offset=${page*limit}&search=${search}`


      jwtAxios
        .get(url, API.requestOptionsGET())
        .then((data) => {
          console.log(data,limit,page)
          if (data.status === 200) {
            dispatch({ type: FETCH_SUCCESS })
            dispatch({type:GET_TITLE_ADMINTOOLS,payload:data.data})
            dispatch({type:UPDATE_DATATABLE_TABLE_INFO,payload:data.data})
            dispatch(updateRows(data.data.results))

          } else {

            dispatch({ type: FETCH_ERROR, payload: data.data })
          }
        })
        .catch((error) => {
          dispatch({ type: FETCH_ERROR, payload: error })
        })
    }
  }

  export const onGetTitleOptions = (name ='',year = '') => {
    return (dispatch) => {
      dispatch({ type: FETCH_START });
      let url = API.GET_TITLE_OPTIONS
      if(name != '' || year !='')
        url += `?year=${year}&name=${name}`
  
  
      jwtAxios
        .get(url, API.requestOptionsGET())
        .then((data) => {
          if (data.status === 200) {
            dispatch({ type: FETCH_SUCCESS })
            dispatch({type:GET_TITLE_OPTIONS,payload:data.data})
  
  
          } else {
  
            dispatch({ type: FETCH_ERROR, payload: data.data })
          }
        })
        .catch((error) => {
          dispatch({ type: FETCH_ERROR, payload: error })
        })
    }
  }


  export const onGetDetailTitle = (id) => {
    return (dispatch) => {
      dispatch({ type: FETCH_START });
      let url = API.GET_TITLE_ADMINTOOLS +id + "/"


      jwtAxios
        .get(url, API.requestOptionsGET())
        .then((data) => {
          console.log(data)
          if (data.status === 200) {
            dispatch({ type: FETCH_SUCCESS })
            dispatch({type:GET_TITLE_DETAIL_ADMINTOOLS,payload:data.data.results})

          } else {

            dispatch({ type: FETCH_ERROR, payload: data.data })
          }
        })
        .catch((error) => {
          dispatch({ type: FETCH_ERROR, payload: error })
        })
    }
  }

  export const onDeactivateTitle = (id) => {
    return (dispatch) => {
      dispatch({ type: FETCH_START });
      let url = API.DEACTIVATE_TITLE_ADMINTOOLS;
      let editedUrl = url.replace('{id}', id);


      jwtAxios
      .put(editedUrl, undefined, API.requestOptionsPUT())
      .then((data) => {
        if (data.status === 200) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({ type: SHOW_MESSAGE, payload: 'Jabatan Berhasil Di Deaktivasi' });

        } else {
          dispatch({type: FETCH_ERROR, payload: data.data});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error});
      });
    }
  }

  export const onActivateTitle = (id) => {
    return (dispatch) => {
      dispatch({ type: FETCH_START });
      let url = API.ACTIVATE_TITLE_ADMINTOOLS;
      let editedUrl = url.replace('{id}', id);
  

      jwtAxios
      .put(editedUrl, undefined, API.requestOptionsPUT())
      .then((data) => {
        if (data.status === 200) {
          dispatch({type: FETCH_SUCCESS});
          dispatch({ type: SHOW_MESSAGE, payload: 'Jabatan Berhasil Diaktivasi' });

        } else {
          dispatch({type: FETCH_ERROR, payload: data.data});
        }
      })
      .catch((error) => {
        dispatch({type: FETCH_ERROR, payload: error});
      });
    }
  }

  export const onCreateProfile = (bodyReq) => {
    return (dispatch) => {
      dispatch({ type: FETCH_START });
      let url = API.GET_PROFILE_ADMINTOOLS


      jwtAxios
        .post(url,bodyReq, API.requestOptionsPOST())
        .then((data) => {
          console.log(data)
          if (data.status === 200) {
            dispatch({ type: FETCH_SUCCESS })
          
            dispatch({ type: SHOW_MESSAGE, payload: 'Jabatan Berhasil Dibuat' });

          } else {

            dispatch({ type: FETCH_ERROR, payload: data.data })
          }
        })
        .catch((error) => {
          dispatch({ type: FETCH_ERROR, payload: error })
        })
    }
  }  